"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorPickerFieldValueGetter = void 0;
const get_field_value_1 = require("../../helpers/get-field-value");
const safe_field_value_1 = require("../../safe-field-value");
const arrays_1 = require("../../type-checking/arrays");
const primitives_1 = require("../../type-checking/primitives");
const typing_1 = require("../../type-checking/typing");
class ColorPickerFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.getEmptyValue = () => [];
        this.getFieldValue = (field, record) => {
            const fieldValue = (0, get_field_value_1.getValueFromRecordBySlug)(record, field);
            if (fieldValue === undefined)
                return this.getEmptyValue();
            if (!this.isValidFieldValue(fieldValue))
                return this.getEmptyValue();
            // Removes the id field from the value. Inside the record modal, color picker objects
            // will have an ID to allow edits to multiple fields at the same time. Before saving
            // the new record data, we need to ensure the ID is removed so the stored value is
            // valid.
            return fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.map((item) => {
                return {
                    name: item.name,
                    value: item.value,
                };
            });
        };
        this.isValidFieldValue = (fieldValue) => {
            return (0, arrays_1.isArrayOfValidObjectsValue)(fieldValue, {
                id: (0, typing_1.Optional)(primitives_1.isStringValue),
                name: (0, typing_1.Optional)(primitives_1.isStringValue),
                value: primitives_1.isStringValue,
            });
        };
    }
}
exports.ColorPickerFieldValueGetter = ColorPickerFieldValueGetter;
